export default "__VITE_ASSET__j7tuhFSd__"